module.exports = __webpack_public_path__ + "media/img/home/directions/direction2-132ade9eace6189cc2858dae05cd6c5e.svg";